import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73646bc9")

_pushScopeId("data-v-73646bc9")
const _hoisted_1 = { class: "flex flex-row gap-6 items-center border-b border-gray-lp-900 pt-2.5" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "font-semibold text-gray-lp-600 border-b-2 border-white pb-2.5 px-4",
        exactActiveClass: "active-link",
        to: "/pickup-dashboard/monitoring/courier"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("pickupDashboard.tabCourierList")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view),
    _createVNode(_component_WidgetDownload)
  ], 64))
})